/* eslint-disable */
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core'
export const BusinessType = {
  CommunityAndNonProfit: 'COMMUNITY_AND_NON_PROFIT',
  ConstructionAndRealEstate: 'CONSTRUCTION_AND_REAL_ESTATE',
  CorporateAndProfessionalServices: 'CORPORATE_AND_PROFESSIONAL_SERVICES',
  EducationAndChildcare: 'EDUCATION_AND_CHILDCARE',
  HealthcareAndClinics: 'HEALTHCARE_AND_CLINICS',
  HospitalityAndFoodServices: 'HOSPITALITY_AND_FOOD_SERVICES',
  Other: 'OTHER',
  RecreationAndEvents: 'RECREATION_AND_EVENTS',
  RetailAndManufacturing: 'RETAIL_AND_MANUFACTURING',
} as const

export type BusinessType = (typeof BusinessType)[keyof typeof BusinessType]
export type CartBypassInput = {
  includeComplianceData?: boolean | null | undefined
  includeFeeData?: boolean | null | undefined
  includeProductData?: boolean | null | undefined
  includePromotionData?: boolean | null | undefined
}

export type CartEmptyInput = {
  customerId: string | number
  retailerData: RetailerDataInput
}

export type CartQueryInput = {
  customerId: string | number
  retailerData: RetailerDataInput
  state?: string | null | undefined
}

export type CartUpdateProductInput = {
  bypassData?: CartBypassInput | null | undefined
  customerId: string | number
  productsData: Array<ProductDataInput | null | undefined>
  retailerData: RetailerDataInput
}

export const CompanySize = {
  Size_2_10: 'SIZE_2_10',
  Size_11_50: 'SIZE_11_50',
  Size_51_200: 'SIZE_51_200',
  Size_201Plus: 'SIZE_201_PLUS',
  SizeJustMe: 'SIZE_JUST_ME',
} as const

export type CompanySize = (typeof CompanySize)[keyof typeof CompanySize]
export type CreateGroupInput = {
  businessType?: BusinessType | null | undefined
  companySize?: CompanySize | null | undefined
  groupType: GroupType
  name: string
  websiteUrl?: string | null | undefined
}

/** Input object with path and array of preference ids */
export type CustomerPreferencePathInput = {
  /** The path for the preference such as products.grocery.food_label */
  path: string
  /** The set of preference ids the customer has chosen */
  preferenceIds?: Array<string> | null | undefined
}

/** Input to updates a customers grocery preferences */
export type CustomerPreferencesUpdateSurveyResponsesInput = {
  /** The customers ID */
  customerId: string
  /** The preference selections for the update - acts like a PUT which means these selections will replace what existed in the database before */
  selections?: Array<CustomerPreferencePathInput> | null | undefined
  /** The survey ID of the survey to update */
  surveyId: string
}

export type GroupMembershipInput = {
  groupId: string | number
  inviteEmail?: string | null | undefined
  userId?: string | number | null | undefined
}

export const GroupType = {
  Business: 'BUSINESS',
} as const

export type GroupType = (typeof GroupType)[keyof typeof GroupType]
export type ProductDataInput = {
  couponId?: string | null | undefined
  description: string
  notes?: string | null | undefined
  productId: string | number
  quantity: number
}

export const ProductType = {
  ByWeight: 'BY_WEIGHT',
  Normal: 'NORMAL',
  Undefined: 'UNDEFINED',
} as const

export type ProductType = (typeof ProductType)[keyof typeof ProductType]
export type RetailerDataInput = {
  metroId: string
  retailerId: string
  storeLocationId: string
}

export type UpdateGroupInput = {
  businessType?: BusinessType | null | undefined
  companySize?: CompanySize | null | undefined
  id: string | number
  name?: string | null | undefined
  websiteUrl?: string | null | undefined
}

export type CustomerPropertyTypesQueryVariables = Exact<{ [key: string]: never }>

export type CustomerPropertyTypesQuery = { addressPropertyTypes: Array<string> }

export type CustomerAddressesQueryVariables = Exact<{
  customerId: string
}>

export type CustomerAddressesQuery = {
  customerAddresses: Array<{
    id: string
    street1: string
    street2: string | null
    city: string
    state: string
    timezone: string
    zip_code: string
    delivery_instructions: string | null
    door_dropoff: boolean | null
    pickup_store_location_id: number | null
    created_at: unknown
    updated_at: unknown
    property_type: string | null
    requested_delivery_location: string | null
    shopper_arrive: Array<string> | null
    gate_code: string | null
  }>
}

export type DeleteCustomerAddressMutationVariables = Exact<{
  customerId: string
  addressId: string
}>

export type DeleteCustomerAddressMutation = {
  deleteCustomerAddress: { deletedId: string | null } | null
}

export type DeliveryInstructionOptionsQueryVariables = Exact<{
  propertyType?: string | null | undefined
}>

export type DeliveryInstructionOptionsQuery = {
  deliveryInstructionOptions: {
    requestedDeliveryLocationOptions: Array<string>
    shopperArriveOptions: Array<string>
  }
}

export type GroupInvitesQueryVariables = Exact<{
  userId: string | number
}>

export type GroupInvitesQuery = { groupInvites: Array<{ id: string; name: string }> | null }

export type PendingInvitesQueryVariables = Exact<{
  groupId: string | number
}>

export type PendingInvitesQuery = {
  pendingGroupInvites: Array<{ email: string; invitedAt: unknown }> | null
}

export type AcceptGroupInviteMutationVariables = Exact<{
  input: GroupMembershipInput
}>

export type AcceptGroupInviteMutation = { acceptGroupInvite: boolean }

export type RejectGroupInviteMutationVariables = Exact<{
  input: GroupMembershipInput
}>

export type RejectGroupInviteMutation = { removeUserFromGroup: boolean }

export type CreateGroupMutationVariables = Exact<{
  input: CreateGroupInput
}>

export type CreateGroupMutation = { createGroup: { id: string; name: string } | null }

export type UpdateGroupMutationVariables = Exact<{
  input: UpdateGroupInput
}>

export type UpdateGroupMutation = {
  updateGroup: {
    id: string
    name: string
    businessType: BusinessType | null
    websiteUrl: string | null
    companySize: CompanySize | null
  } | null
}

export type DietaryPreferencesQueryVariables = Exact<{
  customerId: string
  surveyId: string
}>

export type DietaryPreferencesQuery = {
  customerPreferencesSurveyResponses: {
    selections: Array<{
      path: string
      preferences: Array<{ id: string; name: string; value: unknown }> | null
    }> | null
  } | null
}

export type UpdateDietaryPreferencesMutationVariables = Exact<{
  input: CustomerPreferencesUpdateSurveyResponsesInput
}>

export type UpdateDietaryPreferencesMutation = {
  customerPreferencesUpdateSurveyResponses: { success: boolean } | null
}

export type BaseUserQueryVariables = Exact<{ [key: string]: never }>

export type BaseUserQuery = {
  customer: {
    id: string
    name: string
    email: string
    hasEbtPaymentMethod: boolean | null
    marketingPhone: string | null
    phone: string | null
    exempt: boolean
    platformCustomerId: string
    order_delivery_type: string
    universal_id: string
    has_purchased: boolean
    has_placed_first_order: boolean
    has_placed_marketplace_order: boolean
    defaultAddress: { id: string; metro: { name: string; id: string } | null } | null
    privacyPreferences: Array<{
      path: string
      preferences: Array<{ id: string; value: unknown }> | null
    }> | null
    selectedLocation: { id: string; metro: { id: string; name: string } | null } | null
    selectedRetailer: {
      id: string
      name: string | null
      description: string | null
      background_color: string | null
      hero_image_url: string | null
      require_store_transaction_number_from_shopper: boolean
      circular_image_url: string | null
      image: string | null
    } | null
    subscription: {
      id: string
      status: string
      type: string | null
      plan: { id: string; interval: string | null; intervalCount: number | null }
    } | null
    customerAddresses: Array<{
      id: string
      street1: string
      street2: string | null
      city: string
      state: string
      timezone: string
      deliveryInstructions: string | null
      zip_code: string
      door_dropoff: boolean | null
      pickup_store_location_id: number | null
      property_type: string | null
      requested_delivery_location: string | null
      shopper_arrive: Array<string> | null
      gate_code: string | null
    }>
    groups: Array<{
      id: string
      name: string
      ownerId: string
      businessType: BusinessType | null
      taxExempt: boolean
      websiteUrl: string | null
      companySize: CompanySize | null
    }> | null
  } | null
}

export type UserProfileQueryVariables = Exact<{
  customerId: string | number
}>

export type UserProfileQuery = {
  customer: { id: string; phone: string | null; email: string; name: string } | null
}

export type GetGroupQueryVariables = Exact<{
  id: string | number
}>

export type GetGroupQuery = {
  group: {
    id: string
    name: string
    ownerId: string
    groupType: GroupType
    businessType: BusinessType | null
    users: Array<{ id: string; name: string; email: string }> | null
  } | null
}

export type InviteUserToGroupMutationVariables = Exact<{
  input: GroupMembershipInput
}>

export type InviteUserToGroupMutation = { inviteUserToGroup: boolean }

export type RemoveUserFromGroupMutationVariables = Exact<{
  input: GroupMembershipInput
}>

export type RemoveUserFromGroupMutation = { removeUserFromGroup: boolean }

export type FeaturedPromotionByCategoryQueryVariables = Exact<{
  input: CartQueryInput
  categoryId: string | number
}>

export type FeaturedPromotionByCategoryQuery = {
  cart: {
    promotionSummary: {
      promotionProgress: Array<{
        disclaimerBody: string
        disclaimerHeader: string
        progress: number
        progressHeader: string
      }> | null
    } | null
  }
}

export type CartEmptyMutationVariables = Exact<{
  input: CartEmptyInput
}>

export type CartEmptyMutation = { cartEmpty: { success: boolean } }

export type CartMutationFieldsFragment = {
  id: string
  promotions: {
    dollarTotalQualifyingCredit: number | null
    availablePromotions: Array<{
      categoryId: string | null
      progress: number
      disclaimer_body: string
      disclaimer_header: string
      progress_header: string
      progress_subheader: string
      promotion_id: string
      type: string
    }> | null
  } | null
  shopping_cart_lines: Array<{ item: { id: string } | Record<PropertyKey, never> }>
} & { ' $fragmentName'?: 'CartMutationFieldsFragment' }

export type CartUpdateProductMutationVariables = Exact<{
  input: CartUpdateProductInput
}>

export type CartUpdateProductMutation = {
  cartUpdateProduct: {
    success: boolean
    cart: { ' $fragmentRefs'?: { CartMutationFieldsFragment: CartMutationFieldsFragment } } | null
  }
}

export type ProductFieldsFragment = {
  id: string
  brandName: string | null
  retailerId: string
  storeLocationId: string
  bought: boolean | null
  universalId: string
  allergenInfo: string
  chokingHazard: string | null
  description: string
  descriptionLabels: Array<string> | null
  displayName: string
  ingredients: string
  nmuEligible: boolean
  nutritionalDetails: unknown
  hasAlcoholTerms: boolean
  isCustomProduct: boolean
  isSnapEbtEligible: boolean
  available: boolean
  lowStock: boolean
  outOfStock: boolean
  bogo: boolean
  bulletPoints: Array<string> | null
  hasCustomLabel: boolean | null
  onSale: boolean | null
  price: number | null
  salePrice: number | null
  originalPrice: number | null
  productType: ProductType
  purchaseLimit: number | null
  unitWeight: number | null
  unitOfMeasure: string | null
  size: string
  highlights: Array<string> | null
  specifications: Array<string> | null
  coupons: Array<{
    id: string
    description: string
    disclaimer: string
    summary: string | null
    expiresAt: unknown
    requiredQty: number | null
    faceValue: number
    userState: { clippedAt: unknown } | null
  }> | null
  images: { primary: string; thumbnail: string; secondary: Array<string> | null }
  memberPreferenceData: {
    forYou: boolean | null
    nutritionalAttributesForYou: Array<{ tag: string; description: string | null }> | null
  } | null
  pricing: {
    loyalty: { price: number; startsOn: string | null; endsOn: string | null } | null
  } | null
  stats: {
    averageRating: number
    totalReviews: number
    totalRatings: number
    recommendedPercentage: number
    ratingDistribution: {
      rating1: number
      rating2: number
      rating3: number
      rating4: number
      rating5: number
    } | null
  } | null
  promotions: Array<{
    id: string
    content: { categoryId: string | null; productCallout: string | null } | null
  }> | null
  variationInfo: {
    parentProductId: string
    displayName: string
    sizeOption: { size: string } | null
    colorOption: { color: string; swatchUrl: string } | null
    variationProperties: Array<{ name: string; swatchUrl: string | null; value: string }> | null
  } | null
  rootCryptexCategory: { id: string } | null
} & { ' $fragmentName'?: 'ProductFieldsFragment' }

export type PdpProductQueryVariables = Exact<{
  productId: string
  retailerId: string
  metroId: string
  storeLocationId: string
}>

export type PdpProductQuery = {
  product:
    | ({
        variationInfo: {
          parentProductId: string
          displayName: string
          sizeOption: { size: string } | null
          colorOption: { color: string; swatchUrl: string } | null
          variationProperties: Array<{
            name: string
            swatchUrl: string | null
            value: string
          }> | null
          variantProducts: Array<{
            ' $fragmentRefs'?: { ProductFieldsFragment: ProductFieldsFragment }
          } | null> | null
        } | null
      } & { ' $fragmentRefs'?: { ProductFieldsFragment: ProductFieldsFragment } })
    | null
}

export type ProductUniversalIdQueryVariables = Exact<{
  productId: string
  retailerId: string
  metroId: string
  storeLocationId: string
}>

export type ProductUniversalIdQuery = {
  product: { universalId: string; displayName: string } | null
}

export type MemberSavingsQueryVariables = Exact<{
  memberId: string
}>

export type MemberSavingsQuery = {
  memberOrderOverview: {
    deliveryFeesWaived: number | null
    discountTotal: number | null
    minutesSaved: number | null
  }
}

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>
  private value: string
  public __meta__?: Record<string, any> | undefined

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value)
    this.value = value
    this.__meta__ = __meta__
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value
  }
}
export const CartMutationFieldsFragmentDoc = new TypedDocumentString(
  `
    fragment CartMutationFields on Cart {
  id
  promotions {
    dollarTotalQualifyingCredit: dollarQualifyingCredit
    availablePromotions: promotionProgress {
      categoryId
      disclaimer_body: disclaimerBody
      disclaimer_header: disclaimerHeader
      progress
      progress_header: progressHeader
      progress_subheader: progressSubheader
      promotion_id: promotionId
      type: promotionType
    }
  }
  shopping_cart_lines: items {
    item {
      ... on Product {
        id
      }
    }
  }
}
    `,
  { fragmentName: 'CartMutationFields' },
) as unknown as TypedDocumentString<CartMutationFieldsFragment, unknown>
export const ProductFieldsFragmentDoc = new TypedDocumentString(
  `
    fragment ProductFields on Product {
  id
  brandName
  retailerId
  storeLocationId
  bought
  universalId
  allergenInfo
  coupons {
    id
    description
    disclaimer
    summary
    expiresAt
    requiredQty
    faceValue
    userState {
      clippedAt
    }
  }
  chokingHazard
  description
  descriptionLabels
  displayName
  images {
    primary
    thumbnail
    secondary
  }
  memberPreferenceData {
    nutritionalAttributesForYou {
      tag
      description
    }
    forYou
  }
  ingredients
  nmuEligible
  nutritionalDetails
  hasAlcoholTerms
  isCustomProduct
  isSnapEbtEligible
  available
  lowStock
  outOfStock
  bogo
  bulletPoints
  hasCustomLabel
  onSale
  price
  pricing {
    loyalty {
      price
      startsOn
      endsOn
    }
  }
  salePrice
  originalPrice
  productType
  purchaseLimit
  unitWeight
  unitOfMeasure
  size
  stats {
    averageRating
    ratingDistribution {
      rating1
      rating2
      rating3
      rating4
      rating5
    }
    totalReviews
    totalRatings
    recommendedPercentage
  }
  promotions {
    id
    content {
      categoryId
      productCallout
    }
  }
  variationInfo {
    parentProductId
    displayName
    sizeOption {
      size
    }
    colorOption {
      color
      swatchUrl
    }
    variationProperties {
      name
      swatchUrl
      value
    }
  }
  rootCryptexCategory {
    id
  }
  highlights
  specifications
}
    `,
  { fragmentName: 'ProductFields' },
) as unknown as TypedDocumentString<ProductFieldsFragment, unknown>
export const CustomerPropertyTypesDocument = new TypedDocumentString(`
    query CustomerPropertyTypes {
  addressPropertyTypes
}
    `) as unknown as TypedDocumentString<
  CustomerPropertyTypesQuery,
  CustomerPropertyTypesQueryVariables
>
export const CustomerAddressesDocument = new TypedDocumentString(`
    query CustomerAddresses($customerId: String!) {
  customerAddresses(customerId: $customerId) {
    id
    street1
    street2
    city
    state
    zip_code: zip
    delivery_instructions: deliveryInstructions
    door_dropoff: doorDropOff
    pickup_store_location_id: pickupRetailerLocationId
    created_at: createdAt
    updated_at: updatedAt
    timezone
    property_type: propertyType
    requested_delivery_location: requestedDeliveryLocation
    shopper_arrive: shopperArrive
    gate_code: gateCode
  }
}
    `) as unknown as TypedDocumentString<CustomerAddressesQuery, CustomerAddressesQueryVariables>
export const DeleteCustomerAddressDocument = new TypedDocumentString(`
    mutation DeleteCustomerAddress($customerId: String!, $addressId: String!) {
  deleteCustomerAddress(input: {addressId: $addressId, customerId: $customerId}) {
    deletedId
  }
}
    `) as unknown as TypedDocumentString<
  DeleteCustomerAddressMutation,
  DeleteCustomerAddressMutationVariables
>
export const DeliveryInstructionOptionsDocument = new TypedDocumentString(`
    query DeliveryInstructionOptions($propertyType: PropertyType) {
  deliveryInstructionOptions(propertyType: $propertyType) {
    requestedDeliveryLocationOptions
    shopperArriveOptions
  }
}
    `) as unknown as TypedDocumentString<
  DeliveryInstructionOptionsQuery,
  DeliveryInstructionOptionsQueryVariables
>
export const GroupInvitesDocument = new TypedDocumentString(`
    query GroupInvites($userId: ID!) {
  groupInvites(userId: $userId) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<GroupInvitesQuery, GroupInvitesQueryVariables>
export const PendingInvitesDocument = new TypedDocumentString(`
    query PendingInvites($groupId: ID!) {
  pendingGroupInvites(groupId: $groupId) {
    email
    invitedAt
  }
}
    `) as unknown as TypedDocumentString<PendingInvitesQuery, PendingInvitesQueryVariables>
export const AcceptGroupInviteDocument = new TypedDocumentString(`
    mutation AcceptGroupInvite($input: GroupMembershipInput!) {
  acceptGroupInvite(input: $input)
}
    `) as unknown as TypedDocumentString<
  AcceptGroupInviteMutation,
  AcceptGroupInviteMutationVariables
>
export const RejectGroupInviteDocument = new TypedDocumentString(`
    mutation RejectGroupInvite($input: GroupMembershipInput!) {
  removeUserFromGroup(input: $input)
}
    `) as unknown as TypedDocumentString<
  RejectGroupInviteMutation,
  RejectGroupInviteMutationVariables
>
export const CreateGroupDocument = new TypedDocumentString(`
    mutation CreateGroup($input: CreateGroupInput!) {
  createGroup(input: $input) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<CreateGroupMutation, CreateGroupMutationVariables>
export const UpdateGroupDocument = new TypedDocumentString(`
    mutation UpdateGroup($input: UpdateGroupInput!) {
  updateGroup(input: $input) {
    id
    name
    businessType
    websiteUrl
    companySize
  }
}
    `) as unknown as TypedDocumentString<UpdateGroupMutation, UpdateGroupMutationVariables>
export const DietaryPreferencesDocument = new TypedDocumentString(`
    query DietaryPreferences($customerId: String!, $surveyId: String!) {
  customerPreferencesSurveyResponses(
    input: {customerId: $customerId, includeOnlySelected: false, surveyId: $surveyId}
  ) {
    selections {
      path
      preferences {
        id
        name
        value
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DietaryPreferencesQuery, DietaryPreferencesQueryVariables>
export const UpdateDietaryPreferencesDocument = new TypedDocumentString(`
    mutation UpdateDietaryPreferences($input: CustomerPreferencesUpdateSurveyResponsesInput!) {
  customerPreferencesUpdateSurveyResponses(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<
  UpdateDietaryPreferencesMutation,
  UpdateDietaryPreferencesMutationVariables
>
export const BaseUserDocument = new TypedDocumentString(`
    query BaseUser {
  customer {
    id
    name
    email
    hasEbtPaymentMethod
    defaultAddress {
      id
      metro {
        name
        id
      }
    }
    privacyPreferences {
      path
      preferences {
        id
        value
      }
    }
    marketingPhone
    order_delivery_type: orderDeliveryType
    phone
    selectedLocation {
      id
      metro {
        id
        name
      }
    }
    selectedRetailer {
      id
      name
      background_color: backgroundColor
      description
      hero_image_url: heroImageURL
      require_store_transaction_number_from_shopper: requiresStoreTransactionNumberFromShopper
      circular_image_url: circularImageURL
      image: imageURL
    }
    subscription {
      id
      status
      plan {
        id
        interval
        intervalCount
      }
      type
    }
    exempt
    universal_id: universalId
    has_purchased: hasPurchased
    has_placed_first_order: hasPlacedFirstOrder
    has_placed_marketplace_order: hasPlacedMarketplaceOrder
    platformCustomerId
    customerAddresses {
      id
      street1
      street2
      city
      state
      zip_code: zip
      door_dropoff: doorDropOff
      pickup_store_location_id: pickupRetailerLocationId
      timezone
      deliveryInstructions
      property_type: propertyType
      requested_delivery_location: requestedDeliveryLocation
      shopper_arrive: shopperArrive
      gate_code: gateCode
    }
    groups {
      id
      name
      ownerId
      businessType
      taxExempt
      websiteUrl
      companySize
    }
  }
}
    `) as unknown as TypedDocumentString<BaseUserQuery, BaseUserQueryVariables>
export const UserProfileDocument = new TypedDocumentString(`
    query UserProfile($customerId: ID!) {
  customer(id: $customerId) {
    id
    phone
    email
    name
  }
}
    `) as unknown as TypedDocumentString<UserProfileQuery, UserProfileQueryVariables>
export const GetGroupDocument = new TypedDocumentString(`
    query GetGroup($id: ID!) {
  group(id: $id) {
    id
    name
    ownerId
    groupType
    businessType
    users {
      id
      name
      email
    }
  }
}
    `) as unknown as TypedDocumentString<GetGroupQuery, GetGroupQueryVariables>
export const InviteUserToGroupDocument = new TypedDocumentString(`
    mutation InviteUserToGroup($input: GroupMembershipInput!) {
  inviteUserToGroup(input: $input)
}
    `) as unknown as TypedDocumentString<
  InviteUserToGroupMutation,
  InviteUserToGroupMutationVariables
>
export const RemoveUserFromGroupDocument = new TypedDocumentString(`
    mutation RemoveUserFromGroup($input: GroupMembershipInput!) {
  removeUserFromGroup(input: $input)
}
    `) as unknown as TypedDocumentString<
  RemoveUserFromGroupMutation,
  RemoveUserFromGroupMutationVariables
>
export const FeaturedPromotionByCategoryDocument = new TypedDocumentString(`
    query FeaturedPromotionByCategory($input: CartQueryInput!, $categoryId: ID!) {
  cart(input: $input) {
    promotionSummary(filters: {categoryId: $categoryId, includeEmpty: true}) {
      promotionProgress {
        disclaimerBody
        disclaimerHeader
        progress
        progressHeader
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  FeaturedPromotionByCategoryQuery,
  FeaturedPromotionByCategoryQueryVariables
>
export const CartEmptyDocument = new TypedDocumentString(`
    mutation CartEmpty($input: CartEmptyInput!) {
  cartEmpty(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<CartEmptyMutation, CartEmptyMutationVariables>
export const CartUpdateProductDocument = new TypedDocumentString(`
    mutation CartUpdateProduct($input: CartUpdateProductInput!) {
  cartUpdateProduct(input: $input) {
    success
    cart {
      ...CartMutationFields
    }
  }
}
    fragment CartMutationFields on Cart {
  id
  promotions {
    dollarTotalQualifyingCredit: dollarQualifyingCredit
    availablePromotions: promotionProgress {
      categoryId
      disclaimer_body: disclaimerBody
      disclaimer_header: disclaimerHeader
      progress
      progress_header: progressHeader
      progress_subheader: progressSubheader
      promotion_id: promotionId
      type: promotionType
    }
  }
  shopping_cart_lines: items {
    item {
      ... on Product {
        id
      }
    }
  }
}`) as unknown as TypedDocumentString<CartUpdateProductMutation, CartUpdateProductMutationVariables>
export const PdpProductDocument = new TypedDocumentString(`
    query PdpProduct($productId: String!, $retailerId: String!, $metroId: String!, $storeLocationId: String!) {
  product(
    input: {productId: $productId, retailerId: $retailerId, metroId: $metroId, storeLocationId: $storeLocationId}
  ) {
    ...ProductFields
    variationInfo {
      parentProductId
      displayName
      sizeOption {
        size
      }
      colorOption {
        color
        swatchUrl
      }
      variationProperties {
        name
        swatchUrl
        value
      }
      variantProducts {
        ...ProductFields
      }
    }
  }
}
    fragment ProductFields on Product {
  id
  brandName
  retailerId
  storeLocationId
  bought
  universalId
  allergenInfo
  coupons {
    id
    description
    disclaimer
    summary
    expiresAt
    requiredQty
    faceValue
    userState {
      clippedAt
    }
  }
  chokingHazard
  description
  descriptionLabels
  displayName
  images {
    primary
    thumbnail
    secondary
  }
  memberPreferenceData {
    nutritionalAttributesForYou {
      tag
      description
    }
    forYou
  }
  ingredients
  nmuEligible
  nutritionalDetails
  hasAlcoholTerms
  isCustomProduct
  isSnapEbtEligible
  available
  lowStock
  outOfStock
  bogo
  bulletPoints
  hasCustomLabel
  onSale
  price
  pricing {
    loyalty {
      price
      startsOn
      endsOn
    }
  }
  salePrice
  originalPrice
  productType
  purchaseLimit
  unitWeight
  unitOfMeasure
  size
  stats {
    averageRating
    ratingDistribution {
      rating1
      rating2
      rating3
      rating4
      rating5
    }
    totalReviews
    totalRatings
    recommendedPercentage
  }
  promotions {
    id
    content {
      categoryId
      productCallout
    }
  }
  variationInfo {
    parentProductId
    displayName
    sizeOption {
      size
    }
    colorOption {
      color
      swatchUrl
    }
    variationProperties {
      name
      swatchUrl
      value
    }
  }
  rootCryptexCategory {
    id
  }
  highlights
  specifications
}`) as unknown as TypedDocumentString<PdpProductQuery, PdpProductQueryVariables>
export const ProductUniversalIdDocument = new TypedDocumentString(`
    query ProductUniversalId($productId: String!, $retailerId: String!, $metroId: String!, $storeLocationId: String!) {
  product(
    input: {productId: $productId, retailerId: $retailerId, metroId: $metroId, storeLocationId: $storeLocationId, settingOptional: true, showInactive: true}
  ) {
    universalId
    displayName
  }
}
    `) as unknown as TypedDocumentString<ProductUniversalIdQuery, ProductUniversalIdQueryVariables>
export const MemberSavingsDocument = new TypedDocumentString(`
    query MemberSavings($memberId: String!) {
  memberOrderOverview(memberId: $memberId) {
    deliveryFeesWaived
    discountTotal
    minutesSaved
  }
}
    `) as unknown as TypedDocumentString<MemberSavingsQuery, MemberSavingsQueryVariables>
export const namedOperations = {
  Query: {
    CustomerPropertyTypes: 'CustomerPropertyTypes',
    CustomerAddresses: 'CustomerAddresses',
    DeliveryInstructionOptions: 'DeliveryInstructionOptions',
    GroupInvites: 'GroupInvites',
    PendingInvites: 'PendingInvites',
    DietaryPreferences: 'DietaryPreferences',
    BaseUser: 'BaseUser',
    UserProfile: 'UserProfile',
    GetGroup: 'GetGroup',
    FeaturedPromotionByCategory: 'FeaturedPromotionByCategory',
    PdpProduct: 'PdpProduct',
    ProductUniversalId: 'ProductUniversalId',
    MemberSavings: 'MemberSavings',
  },
  Mutation: {
    DeleteCustomerAddress: 'DeleteCustomerAddress',
    AcceptGroupInvite: 'AcceptGroupInvite',
    RejectGroupInvite: 'RejectGroupInvite',
    CreateGroup: 'CreateGroup',
    UpdateGroup: 'UpdateGroup',
    UpdateDietaryPreferences: 'UpdateDietaryPreferences',
    InviteUserToGroup: 'InviteUserToGroup',
    RemoveUserFromGroup: 'RemoveUserFromGroup',
    CartEmpty: 'CartEmpty',
    CartUpdateProduct: 'CartUpdateProduct',
  },
  Fragment: {
    CartMutationFields: 'CartMutationFields',
    ProductFields: 'ProductFields',
  },
}
export const QueryNames = namedOperations.Query
export const MutationNames = namedOperations.Mutation
